exports.shouldUpdateScroll= () => {
  // Disables scroll to last position behavior on page load
  return false;
}